import { customerListCollection } from '@finance-hub/domain/customers/blocs/collections/customer-list-collection';

/**
 * Removes every customer row. The collection outlives the screen, so the
 * loader clears it on unmount rather than letting rows accumulate.
 */
export const clearCustomerListCollection = (): void => {
  const keys = [...customerListCollection.keys()];
  if (keys.length > 0) {
    customerListCollection.delete(keys);
  }
};
